// extracted by mini-css-extract-plugin
export default {"button":"Btn_button__y7bxR"};